import React from "react";
import { SwitchUserFormAdditionalActionsContext } from "./context";

export const useSwitchUserFormAdditionalActions = () => {
  const context = React.useContext(SwitchUserFormAdditionalActionsContext);
  return context;
};
